import "./Table.css";
import { Search } from "@mui/icons-material";

// --| Input Search to filter the table based on the search function prop passed
const TableSearch = ({ searchTableFunc, placeholder, value }) => (
  <div className="search_container">
    <Search />
    <input
      type="search"
      placeholder={placeholder}
      onChange={searchTableFunc}
      className="table_search"
      value={value}
    />{" "}
  </div>
);

export { TableSearch };
